import { Checkbox, message } from "antd";
import {
  INSTALLATION_LIST_QUERY_KEY,
  useInstallationUpdate,
} from "hooks/queries/useInstallation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { InstallationSchema } from "types/installation";

export function ImportantCheckbox({
  installation,
}: {
  installation: InstallationSchema;
}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [optimisticCheck, setOptimisticCheck] = useState(
    installation.isImportant,
  );

  const { mutate, isLoading } = useInstallationUpdate(installation.id);

  const onChange = (v: boolean) => {
    setOptimisticCheck(v);
    mutate(
      { isImportant: v },
      {
        onSuccess: () => {
          message.success(t("general:updatedSuccess"));
          queryClient.invalidateQueries(INSTALLATION_LIST_QUERY_KEY);
        },
        onError: () => {
          setOptimisticCheck((v) => !v);
          message.error(t("general:updateFail"));
        },
      },
    );
  };

  return (
    <Checkbox
      checked={optimisticCheck}
      onChange={(e) => onChange(e.target.checked)}
      disabled={isLoading}
    >
      {t("orders:isImportant")}
    </Checkbox>
  );
}
